import { AddressPopup } from "@modules/study/common";
import styles from "./address_section.module.scss";

export const ContactusAddressSection = () => {
  return (
    <section>
      <div className="container">
        <div className={styles.address_wrapper}>
          <AddressPopup />
        </div>
      </div>
    </section>
  );
};

export default ContactusAddressSection;
